import { Box, styled } from '@mui/material';

const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: '#fefefe',
  overflow: 'hidden',
}));

export { Container };
